import { Theme, ThemeProps } from '@theme/base';
import { useSelector } from 'react-redux';
import { getRecentlyViewed, RecentlyViewedItem } from '@state/slices/recently-viewed';
import React from 'react';
import { RecentlyViewed } from '@components/recently-viewed/RecentlyViewed';
import { Component as ComponentContainer, SectionContainer } from '@styles/layout';
import styled from '@emotion/styled';
import { useI18NextContext } from '@components/hooks';
import { withIsServer } from '@components/hoc';
import { AppVariant } from '@model/config/brands';

export interface RecentlyViewedCarouselContainerProps {
  theme?: Theme;
  isServer?: boolean;
}

const Container = styled(ComponentContainer)(({ theme }: ThemeProps) => ({
  paddingTop: theme.custom.spacing.xxxLarge,
  paddingBottom: theme.custom.spacing.xxxLarge
}));

export const RecentlyViewedCarouselContainer = withIsServer((props: RecentlyViewedCarouselContainerProps) => {
  const isWhiteLabel = AppVariant.isWhitelabel();
  const recentlyViewed: Array<RecentlyViewedItem> = useSelector(getRecentlyViewed);
  const t: any = useI18NextContext();
  const { isServer, ...ownProps } = props;

  if (isServer || isWhiteLabel || !recentlyViewed.length) {
    return null;
  }

  return (
    <SectionContainer>
      <Container>
        <RecentlyViewed {...ownProps} recentlyViewed={recentlyViewed} title={t('recently-viewed__header--label')} />
      </Container>
    </SectionContainer>
  );
});
